var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHungama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 2341,
    height: 575,
    transform: "translate(15.46 411.16) scale(0.45)",
    xlinkHref: "../../../../../../Downloads/Hungama_logo.png"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHungama);
export default __webpack_public_path__ + "static/media/hungama.c1c6a5dcf79a3437c50e51b48450bd5f.svg";
export { ForwardRef as ReactComponent };